import { Route } from '@angular/router';

export enum BadgeDataToken {
  ACCESS_REQUEST = 'ACCESS_REQUEST'
}

export type ExtendedRoute = Route & {
  icon?: string;
  text?: string;
  hidden?: boolean;
  badgeData?: BadgeDataToken;
};

export type ExtendedRoutes = ExtendedRoute[];
